import {
    GOOGLE_MAP_INIT,
    GOOGLE_MAP_CLOSE,
    GOOGLE_MAP_ZOOM_CHANGE,
    GOOGLE_MAP_CHANGE_URL,
    GOOGLE_MAP_CHANGE_SATELLITE_VIEW,
    GOOGLE_MAP_CHECKBOX_CHANGE,
    GOOGLE_MAP_CHANGE_STREETVIEW_URL,
    GOOGLE_MAP_TOGGLE_STREETVIEW_EXPAND,
    GOOGLE_MAP_TOGGLE_COLLAPSED,
} from './constants'

export function googleMapInit(id, addresses, activeAddress, activeAddressZoom, showRegistered, showBranch, showShops) {
    return {
        type: GOOGLE_MAP_INIT,
        data: {
            id,
            addresses,
            activeAddress,
            activeAddressZoom,
            showRegistered,
            showBranch,
            showShops,
        },
    }
}

export function googleMapClose(id) {
    return {
        type: GOOGLE_MAP_CLOSE,
        data: {
            id,
        },
    }
}

export function googleMapChangeZoom(id, activeAddressZoom) {
    return {
        type: GOOGLE_MAP_ZOOM_CHANGE,
        data: {
            id,
            activeAddressZoom,
        },
    }
}

export function googleMapChangeSatelliteView(id) {
    return {
        type: GOOGLE_MAP_CHANGE_SATELLITE_VIEW,
        data: {
            id,
        },
    }
}

export function googleMapChangeUrl(
    id,
    addresses,
    activeAddress,
    activeAddressZoom,
    showRegistered,
    showBranch,
    showShops,
    satelliteView
) {
    return {
        type: GOOGLE_MAP_CHANGE_URL,
        data: {
            id,
            addresses,
            activeAddress,
            activeAddressZoom,
            satelliteView,
            showRegistered,
            showBranch,
            showShops,
        },
    }
}

export function googleMapCheckboxChange(id, checkBoxName, checked) {
    return {
        type: GOOGLE_MAP_CHECKBOX_CHANGE,
        data: {
            id,
            checkBoxName,
            checked,
        },
    }
}

export function googleMapChangeStreetViewUrl(id, activeAddress) {
    return {
        type: GOOGLE_MAP_CHANGE_STREETVIEW_URL,
        data: {
            id,
            activeAddress,
        },
    }
}

export function googleMapToggleExpandedStreetView(id, value) {
    return {
        type: GOOGLE_MAP_TOGGLE_STREETVIEW_EXPAND,
        data: {
            id,
            value,
        },
    }
}

export function googleMapToggleCollapsed(id, value) {
    return {
        type: GOOGLE_MAP_TOGGLE_COLLAPSED,
        data: {
            id,
            value,
        },
    }
}
